import React, { Component } from 'react';

import { formatMoney, formatValidation, multipleValidate } from '../../../../../../../helpers/functions';
import DEFINE, { DATE_TIME_FORMAT } from '../../../../../../../constants/Define';
import { ParamsClass } from '../../../../../../../constants/ColorPage';

import {
    DatePickerComponent, StatusComponent, FormWrapperInputComponent
} from "../../../../../common/component/Index";
import Wrapper from '../../../../../common/component/Wrapper';
import Collapse, { Panel } from '../../../../../common/component/Collapse';
import Tabs, { TabPane } from '../../../../../common/component/Tabs';
import Ripple from '../../../../../common/component/Ripple';
import Span from '../../../../../common/component/Span';
import Modal from '../../../../../common/component/Modal';
import AntSelect, { AntOption } from '../../../../../common/component/AntSelect';
import Switch from '../../../../../common/component/Switch';
import Input from '../../../../../common/component/Input';

import TourLineContent from './TourLineContent';
import TourLineBulkCreate from './TourLineBulkCreate';

import { Icon, Empty, Card, Checkbox, List, message } from 'antd';
import moment from 'moment';
import { find, cloneDeep } from 'lodash';
import $ from 'jquery';

import './DepartureDate.less';

const ALL_TOUR_TICKET = 'ALL';

export default class DepartureDate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            validationTourLine: [],
            bulkDateRange: [],
            selectedTourTicketId: ALL_TOUR_TICKET,
            selectedTourLineIds: [],
            showBulkUpdate: false,
            bulkUpdateData: {
                seats: undefined,
                isEnabled: true,
                tourItemId: undefined,
                tourTicketItemIds: [],
            },
            bulkUpdateValidation: {},
        };
    }

    componentDidMount() {
        this.props.getAllTickets()
        this.loadTourTicketsByTour(this.props);
    }

    componentDidUpdate(prevProps) {
        if (this.props.tour?.id && this.props.tour?.id !== prevProps.tour?.id) {
            this.loadTourTicketsByTour(this.props);
        }
        if (this.props.tourLines !== prevProps.tourLines) {
            this.syncSelectedTourLines();
        }
    }

    loadTourTicketsByTour = (props) => {
        const tourId = props.tour?.id;
        if (tourId && props.getAllTicketsById) {
            props.getAllTicketsById(tourId);
        }
    }

    render() {
        const { t, tourLines, dateRange, dateRanges, tour, isShowBulkCreate, allowUpdate, isTour, loading } = this.props;
        const { bulkDateRange, selectedTourLineIds } = this.state;
        const hasSelectedTourLines = selectedTourLineIds.length > 0;
        return (
            <Wrapper className="tour-detail-departure-date row">
                <Wrapper className="col-md-12 mt-2 mb-2">
                    <Wrapper className="col-md-12 p-0 mb-1">
                        <b>Chọn Vé và biến đổi giá</b>
                    </Wrapper>
                    <AntSelect
                        showArrow
                        showSearch
                        value={this.state.selectedTourTicketId}
                        onChange={this.onChangeTourTicketFilter}
                        style={{ width: '100%' }}
                        filterOption={this.selectFilterSearch}
                    >
                        <AntOption value={ALL_TOUR_TICKET}>Tất cả</AntOption>
                        {this.getTourTickets().map(ticket => (
                            <AntOption key={ticket.id} value={ticket.id}>
                                {ticket.name}
                            </AntOption>
                        ))}
                    </AntSelect>
                </Wrapper>
                { isTour && <Wrapper className="col-md-6 mt-2">
                    <Span className="ml-4 mr-4">{t(`item.tour.months`)}</Span>
                    <Span className="ml-3 pl-4">{t(`item.tour.departureDates`)}</Span>
                </Wrapper>
                }
                <Wrapper className={`${isTour ? 'col-md-6' : 'col-md-12'} button-panel`}>
                    { isTour && 
                        <Ripple 
                            color="white" 
                            className="btn" 
                            disabled={!allowUpdate || hasSelectedTourLines}
                            onClick={this.onClickBulkCreate}>
                                <Icon type="plus" className="mr-2" />{t('action.addMulti')}
                        </Ripple>
                    }
                    { (isTour || (!isTour && tourLines.length === 0)) &&  
                        <Ripple 
                            color="white" 
                            className="btn ml-2" 
                            disabled={!allowUpdate || hasSelectedTourLines}
                            onClick={this.onClickCreate}>
                                <Icon type="plus" className="mr-2" />{t('action.add')}
                        </Ripple>
                    }
                    <Ripple
                        color="white"
                        className="btn ml-2"
                        disabled={!allowUpdate || !hasSelectedTourLines}
                        onClick={this.onClickBulkDelete}>
                            <Icon type="close" className="mr-2" />Xóa hàng loạt
                    </Ripple>
                    <TourLineBulkCreate visible={isShowBulkCreate}
                        dateRange={bulkDateRange}
                        tourId={tour.id}
                        onSave={this.onBulkCreate}
                        onInitTickets={this.props.onInitTickets}
                        onCancel={() => this.props.showBulkCreate(false)}
                        tour={this.props.tour}
                        tourTickets={this.getTourTickets()}
                        initialSelectedTourTickets={this.getSelectedTourTickets()}
                        loading={loading}
                    />
                </Wrapper>
                { isTour && 
                    (!!dateRanges.length
                    ? <Tabs
                        activeKey={dateRange[0] && dateRange[0].format(DATE_TIME_FORMAT.SHORT_MONTH)}
                        tabPosition={'left'}
                        style={{ height: '100%' }}
                        className="mt-2 col-md-12"
                        onChange={this.onTabChange}
                    >
                        {dateRanges.map(item => (
                            <TabPane 
                                tab={this.renderMonthTab(item)} 
                                key={item.dateRange[0].format(DATE_TIME_FORMAT.SHORT_MONTH)}>
                                {/* <Wrapper className="tour-lines">
                                    {tourLines.length > 0 ?
                                        <Collapse bordered={false}
                                            expandIconPosition={'right'}
                                            expandIcon={({ isActive }) => 
                                                    allowUpdate && <Icon 
                                                                type="edit" 
                                                                style={{ color: isActive ? ParamsClass['@primary-color'] : undefined }} />}
                                        >
                                            {tourLines.map((tourLine, index) => (
                                                <Panel style={{
                                                    background: index % 2 === 0 ? '#f9f9f9' : '#ffffff',
                                                    borderRadius: 4,
                                                    marginBottom: 5,
                                                    border: '1px dotted #e8e8e8',
                                                    overflow: 'hidden',
                                                }}
                                                    className={`tour-lines-item ${!tourLine.id && 'new-tourline'}`}
                                                    key={tourLine.id || index}
                                                    header={this.renderTourLineHeader(tourLine, index)}
                                                    extra={
                                                        <Icon type="delete" className="mr-2 btn-delete" onClick={e => this.onRemoveTourLine(e, tourLine, index)} />
                                                    }>
                                                    {this.renderTourLineContent(tourLine, index)}
                                                </Panel>
                                            ))}
                                        </Collapse>
                                        : <Empty description={t(`action.noData`)} />
                                    }
                                </Wrapper> */}
                                {this.renderCollapseTourlines()}
                            </TabPane>
                        ))
                        }
                    </Tabs>
                    : tourLines.length > 0
                        ? this.renderCollapseTourlines('mt-2 col-md-12')
                        : <Empty className="mt-2 col-md-12" description={t(`action.noData`)} />
                    )
                }
                {
                    !isTour && this.renderCollapseTourlines('tour-lines-voucher')
                }
            </Wrapper>
        )
    }

    renderCollapseTourlines(customClass = '') {
        const { allowUpdate, t } = this.props
        const tourLines = this.getFilteredTourLines();
        return (
            <Wrapper className={`tour-lines ${customClass}`}>
                {tourLines.length > 0 ?
                    <Collapse bordered={false}
                        expandIconPosition={'right'}
                        expandIcon={({ isActive }) => 
                                allowUpdate && <Icon 
                                            type="edit" 
                                            style={{ color: isActive ? ParamsClass['@primary-color'] : undefined }} />}
                    >
                        {tourLines.map((tourLineData, index) => {
                            const isSelected = this.isTourLineSelected(tourLineData.tourLine);
                            return (
                            <Panel style={{
                                background: isSelected ? '#eaf2ff' : (index % 2 === 0 ? '#f9f9f9' : '#ffffff'),
                                borderRadius: 4,
                                marginBottom: 5,
                                border: '1px dotted #e8e8e8',
                                overflow: 'hidden',
                            }}
                                className={`tour-lines-item ${!tourLineData.tourLine.id && 'new-tourline'}`}
                                key={tourLineData.tourLine.id || index}
                                header={this.renderSelectableTourLineHeader(tourLineData.tourLine, tourLineData.index)}
                                extra={
                                    <Icon type="delete" className="mr-2 btn-delete" onClick={e => this.onRemoveTourLine(e, tourLineData.tourLine, tourLineData.index)} />
                                }>
                                {this.renderTourLineContent(tourLineData.tourLine, tourLineData.index)}
                            </Panel>
                        )})}
                    </Collapse>
                    : <Empty description={t(`action.noData`)} />
                }
            </Wrapper>
        )
    }

    renderMonthTab(item) {
        const monthText = item.dateRange[0].format(DATE_TIME_FORMAT.SHORT_MONTH);
        const activeMonthText = this.props.dateRange[0] && this.props.dateRange[0].format(DATE_TIME_FORMAT.SHORT_MONTH);
        const isActiveMonth = monthText === activeMonthText;
        const checked = isActiveMonth && this.isCurrentMonthAllSelected();
        const indeterminate = isActiveMonth && this.isCurrentMonthIndeterminate();
        return (
            <Span className="tour-line-month-select">
                <Checkbox
                    disabled={!isActiveMonth}
                    checked={checked}
                    indeterminate={indeterminate}
                    onClick={e => e.stopPropagation()}
                    onChange={e => this.onToggleCurrentMonth(e.target.checked)}
                />
                <Span className="ml-2">{monthText}</Span>
            </Span>
        )
    }

    renderSelectableTourLineHeader(tourLine, index) {
        return (
            <Wrapper className="tour-line-selectable-header">
                <Checkbox
                    className="tour-line-select-checkbox"
                    disabled={!tourLine.id}
                    checked={this.isTourLineSelected(tourLine)}
                    onClick={e => e.stopPropagation()}
                    onChange={e => this.onToggleTourLine(tourLine, e.target.checked)}
                />
                {this.renderTourLineHeader(tourLine, index)}
            </Wrapper>
        )
    }

    renderBulkUpdateModal() {
        const { t, loading } = this.props;
        const { showBulkUpdate, bulkUpdateData, bulkUpdateValidation } = this.state;
        const selectedTicket = this.getBulkSelectedTourTicket();
        const tourTicketItems = selectedTicket?.tourTicketItems || [];
        return (
            showBulkUpdate && <Modal
                className="tour-line-bulk-update"
                width={900}
                visible={showBulkUpdate}
                title="Cập nhật hàng loạt Kế hoạch bán"
                onOk={this.onSaveBulkUpdate}
                okText={t('action.update')}
                onCancel={this.onCancelBulkUpdate}
                cancelText={t('action.cancel')}
                confirmLoading={loading}
            >
                <Wrapper className="col-md-12 row">
                    <Wrapper className="col-md-9">
                        <FormWrapperInputComponent
                            isRequired={true}
                            isValidation={true}
                            dataValidation={bulkUpdateData.seats}
                            validation={bulkUpdateValidation.seats}
                            labelTitle={t(`item.tour.seat`)}
                        >
                            <Input
                                placeholder=""
                                type="number"
                                className="form-control"
                                name="seats"
                                onChange={e => this.onChangeBulkUpdate('seats', e.target.value === '' ? undefined : Number(e.target.value))}
                                value={bulkUpdateData.seats === undefined ? '' : bulkUpdateData.seats}
                            />
                        </FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-3">
                        <FormWrapperInputComponent labelTitle={t(`item.tour.isEnabled`)}>
                            <Switch
                                checked={bulkUpdateData.isEnabled}
                                onChange={checked => this.onChangeBulkUpdate('isEnabled', checked)}
                            />
                        </FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-7 mt-3">
                        <FormWrapperInputComponent labelTitle="Tạo thêm ticket">
                            <AntSelect
                                allowClear
                                showArrow
                                showSearch
                                value={bulkUpdateData.tourItemId}
                                onChange={this.onChangeBulkTicket}
                                style={{ width: '100%' }}
                                filterOption={this.selectFilterSearch}
                            >
                                {this.getTourTickets().map(ticket => (
                                    <AntOption key={ticket.id} value={ticket.id}>
                                        {ticket.name}
                                    </AntOption>
                                ))}
                            </AntSelect>
                        </FormWrapperInputComponent>
                    </Wrapper>
                    {tourTicketItems.length > 0 &&
                        <Wrapper className="col-md-10 mt-2 tour-line-bulk-ticket-items">
                            <b>Vé đối tượng</b>
                            <List
                                size="small"
                                dataSource={tourTicketItems}
                                renderItem={item =>
                                    <List.Item>
                                        <Checkbox
                                            checked={(bulkUpdateData.tourTicketItemIds || []).includes(item.id)}
                                            onChange={e => this.onChangeBulkTicketItem(item.id, e.target.checked)}
                                        >
                                            {`${item?.code || ''} - ${item?.objectType?.name || ''} - ${(item?.salePrice || 0).toLocaleString()} ${t(`currency`)}`}
                                        </Checkbox>
                                    </List.Item>
                                }
                            />
                        </Wrapper>
                    }
                </Wrapper>
            </Modal>
        )
    }

    renderTourLineHeader(tourLine, index) {
        const { t, isTour, tour } = this.props;
        return (
            <Wrapper className="col-md-12 row tour-lines-header">
                <Wrapper className="col-md-2 tour-lines-header-title">
                    { 
                        isTour ?
                            <Span>{t(`item.tour.departureDate`)}</Span> 
                        :
                            <Span>{t(`item.tour.saleDate`)}</Span> 
                    }
                </Wrapper>
                <Wrapper className="col-md-2 tour-lines-header-title"><Span>{t(`item.tour.seat`)}</Span></Wrapper>
                <Wrapper className="col-md-3 tour-lines-header-title"><Span>{t(`item.tour.totalSoldQuantity`)}</Span></Wrapper>
                <Wrapper className="col-md-3 tour-lines-header-title"/>
                <Wrapper className="col-md-2 tour-lines-header-title"><Span>{t(`item.tour.isEnabledTitle`)}</Span></Wrapper>
                <Wrapper className="col-md-2 tour-lines-header-value">
                    { 
                        isTour ? 
                            <Span>{tourLine.departureDate && tourLine.departureDate.format(DATE_TIME_FORMAT.SHORT_DATE)}</Span> 
                        :
                            <Span>
                               <b>{`${moment(tour.saleStartDate).format(DATE_TIME_FORMAT.SHORT_DATE)} - ${moment(tour.saleEndDate).format(DATE_TIME_FORMAT.SHORT_DATE)}`}</b>
                            </Span>
                    }
                </Wrapper>
                <Wrapper className="col-md-2 tour-lines-header-value"><Span>{tourLine.seats}</Span></Wrapper>
                <Wrapper className="col-md-3 tour-lines-header-value"><Span>{tourLine.soldQuantity}</Span></Wrapper>
                <Wrapper className="col-md-3 tour-lines-header-value"/>
                <Wrapper className="col-md-2 tour-lines-header-value">
                    <Span><StatusComponent color={tourLine.isEnabled ? 'green' : 'red'}
                        label={tourLine.isEnabled ? this.props.t('item.tour.isEnabled') : this.props.t('item.tour.isDisabled')} /></Span>
                </Wrapper>
            </Wrapper>
        )
    }

    renderPrices(original, sale, currency) {
        return (
            <Span className="prices">
                <Span className={sale ? "prices-sale" : ''}>{original ? formatMoney(original) : ''}</Span>{`${sale ? formatMoney(sale) : ''} ${currency || ''}`}
            </Span>
        )
    }

    renderTourLineContent(tourLine, index) {
        const { allowUpdate, isTour } = this.props
        const validation = this.state.validationTourLine;
        return (
            <TourLineContent 
                allowUpdateContent={allowUpdate}
                tour={this.props.tour}
                isTour={isTour}
                tourLine={tourLine}
                getItemTicket={this.props.getItemTicket}
                index={index}
                validation={validation}
                onChange={this.props.onChange}
                onSelectDate={this.onSelectDepartureDate}
                onSave={this.onSaveTourLine}
                onInitTickets={this.props.onInitTickets}
                onValidate={this.validateTourLine} />
        )
    }

    onSelectDateRange = (dateRange) => {
        // const dateRange = this.getMonthRangeFromDate(range);
        return this.props.onChangeDateRange(dateRange);
    }

    onTabChange = (monthStringKey) => {
        const { dateRanges } = this.props;
        const range = find(dateRanges, item => item.dateRange[0].format(DATE_TIME_FORMAT.SHORT_MONTH) === monthStringKey);
        if (range) {
            this.setState({ selectedTourLineIds: [] });
            return this.onSelectDateRange(range.dateRange)
        }
    }

    onClickCreate = () => {
        const { tourLines } = this.props;
        this.props.onCreate(!!tourLines.length ? tourLines[tourLines.length-1] : undefined);
        let clickTimeout = setTimeout(() => {
            $('.tour-detail-departure-date .tour-lines .ant-collapse-item:last-child .ant-collapse-header[aria-expanded="false"]').click();
            const newElm = $('.new-tourline')
            if (newElm.length > 0) {
                newElm[newElm.length - 1].scrollIntoView({behavior: "smooth"})
            }
            clearTimeout(clickTimeout);
        }, 300);
    }

    // getMonthRangeFromDate(momentDate, momentEndDate) {
    //     return [new moment(momentDate.toISOString()).startOf('month').add(1, 'days'), momentEndDate ? momentEndDate.endOf('month') : momentDate.endOf('month')]
    // }

    onSelectDepartureDate = (date, index) => {
        return this.props.onChange(index, 'departureDate', date.fullValue)
    }

    onSaveTourLine = (tourLine, index) => {
        if (this.validateTourLine(tourLine, index)) {
            return this.props.onSave(tourLine, index)
        }
    }

    onClickBulkCreate = () => {
        const { tourLines } = this.props;

        const lastTourLine = cloneDeep(tourLines[tourLines.length - 1]) || undefined;
        let bulkDateRange = [null, null];
        // if(lastTourLine){
        //     bulkDateRange =  [
        //         cloneDeep(lastTourLine.departureDate),
        //         lastTourLine.departureDate && cloneDeep(lastTourLine.departureDate.endOf('months')),
        //     ],
        // }
        this.setState({ bulkDateRange });
        this.props.showBulkCreate(true)
    }

    onBulkCreate = (tourLineBulk) => {
        // this.setState({ showBulkCreate: false });
        const selectedTourTickets = tourLineBulk.selectedTourTickets || this.getSelectedTourTickets();
        const tourTicketItemIds = tourLineBulk.tourTicketItemIds || selectedTourTickets.reduce((ids, ticket) => {
            return ids.concat((ticket.tourTicketItems || []).map(item => item.id));
        }, []);
        return this.props.onBulkCreate({
            ...tourLineBulk,
            selectedTourTickets,
            tourTicketItemIds,
        })
    }

    onClickBulkUpdate = () => {
        this.setState({
            showBulkUpdate: true,
            bulkUpdateData: {
                seats: undefined,
                isEnabled: true,
                tourItemId: undefined,
                tourTicketItemIds: [],
            },
            bulkUpdateValidation: {},
        });
    }

    onCancelBulkUpdate = () => {
        this.setState({ showBulkUpdate: false });
    }

    onSaveBulkUpdate = () => {
        if (!this.validateBulkUpdate()) {
            message.error(this.props.t('validation.checkForm'));
            return;
        }
        const { bulkUpdateData } = this.state;
        const selectedTourLines = this.getSelectedTourLines();
        this.props.onBulkUpdate({
            ...bulkUpdateData,
            tourLines: selectedTourLines,
            selectedTourTicket: this.getBulkSelectedTourTicket(),
        });
        this.setState({ showBulkUpdate: false, selectedTourLineIds: [] });
    }

    onClickBulkDelete = () => {
        const { confirm } = Modal;
        confirm({
            title: 'Xác nhận xóa hàng loạt các Kế hoạch bán đã chọn?',
            okText: this.props.t(`action.remove`),
            cancelText: this.props.t(`action.cancel`),
            onOk: () => {
                this.props.onBulkDelete(this.getSelectedTourLines());
                this.setState({ selectedTourLineIds: [] });
            },
        });
    }

    onChangeBulkUpdate = (fieldName, value) => {
        this.setState({
            bulkUpdateData: {
                ...this.state.bulkUpdateData,
                [fieldName]: value,
            },
        });
    }

    onChangeBulkTicket = (tourItemId) => {
        this.setState({
            bulkUpdateData: {
                ...this.state.bulkUpdateData,
                tourItemId,
                tourTicketItemIds: [],
            },
        });
    }

    onChangeBulkTicketItem = (id, checked) => {
        const currentIds = this.state.bulkUpdateData.tourTicketItemIds || [];
        const tourTicketItemIds = checked
            ? [...currentIds, id]
            : currentIds.filter(itemId => itemId !== id);
        this.setState({
            bulkUpdateData: {
                ...this.state.bulkUpdateData,
                tourTicketItemIds,
            },
        });
    }

    onToggleTourLine = (tourLine, checked) => {
        const currentIds = this.state.selectedTourLineIds;
        const selectedTourLineIds = checked
            ? (currentIds.includes(tourLine.id) ? currentIds : [...currentIds, tourLine.id])
            : currentIds.filter(id => id !== tourLine.id);
        this.setState({ selectedTourLineIds });
    }

    onToggleCurrentMonth = (checked) => {
        this.setState({
            selectedTourLineIds: checked ? this.getSelectableTourLineIds() : [],
        });
    }

    onChangeTourTicketFilter = (selectedTourTicketId) => {
        this.setState({ selectedTourTicketId, selectedTourLineIds: [] });
        this.props.onChangeTourTicketFilter(selectedTourTicketId);
    }

    getTourTickets = () => {
        return this.props.tourTicket?.allTourTicketsByIds || [];
    }

    getSelectedTourTickets = () => {
        const tourTickets = this.getTourTickets();
        if (this.state.selectedTourTicketId === ALL_TOUR_TICKET) {
            return tourTickets;
        }
        return tourTickets.filter(ticket => ticket.id === this.state.selectedTourTicketId);
    }

    getBulkSelectedTourTicket = () => {
        const { tourItemId } = this.state.bulkUpdateData;
        return this.getTourTickets().find(ticket => ticket.id === tourItemId);
    }

    getSelectedTourLines = () => {
        return this.props.tourLines.filter(tourLine => this.state.selectedTourLineIds.includes(tourLine.id));
    }

    getSelectableTourLineIds = () => {
        return this.props.tourLines.filter(tourLine => !!tourLine.id).map(tourLine => tourLine.id);
    }

    isTourLineSelected = (tourLine) => {
        return !!tourLine.id && this.state.selectedTourLineIds.includes(tourLine.id);
    }

    isCurrentMonthAllSelected = () => {
        const selectableIds = this.getSelectableTourLineIds();
        return selectableIds.length > 0 && selectableIds.every(id => this.state.selectedTourLineIds.includes(id));
    }

    isCurrentMonthIndeterminate = () => {
        const selectableIds = this.getSelectableTourLineIds();
        const selectedCount = selectableIds.filter(id => this.state.selectedTourLineIds.includes(id)).length;
        return selectedCount > 0 && selectedCount < selectableIds.length;
    }

    syncSelectedTourLines = () => {
        const selectableIds = this.getSelectableTourLineIds();
        const selectedTourLineIds = this.state.selectedTourLineIds.filter(id => selectableIds.includes(id));
        if (selectedTourLineIds.length !== this.state.selectedTourLineIds.length) {
            this.setState({ selectedTourLineIds });
        }
    }

    getFilteredTourLines = () => {
        const { tourLines } = this.props;
        return tourLines.map((tourLine, index) => ({ tourLine, index }));
    }

    validateBulkUpdate = () => {
        const { t } = this.props;
        const { bulkUpdateData } = this.state;
        const validate = {
            required: {
                seats: formatValidation(t('validation.statusCode.code.1'), t(`item.tour.seat`)),
            },
        };
        const result = multipleValidate(bulkUpdateData, validate, {});
        this.setState({ bulkUpdateValidation: result });
        return Object.keys(result).length < 1;
    }

    selectFilterSearch = (input, option) => {
        const optionText = String(option.props.children || '').toLowerCase();
        const inputText = input.toLowerCase();
        return optionText.indexOf(inputText) >= 0;
    }

    onRemoveTourLine = (e, tourLine, index) => {
        const { t } = this.props;
        const { confirm } = Modal;
        e.stopPropagation();
        confirm({
            title: t(`notification.sureRemove`),
            okText: t(`action.remove`),
            cancelText: t(`action.cancel`),
            onOk: () => {
                this.props.onRemove(tourLine, index);
            },
        });
    }

    validateTourLine(tourLine, index) {
        const { t, isTour } = this.props;
        let validate = {
            required: {
                // departureDate: formatValidation(t('validation.statusCode.code.1'), t(`item.tour.departureDate`)),
                seats: formatValidation(t('validation.statusCode.code.1'), t(`item.tour.seat`)),
            }
        };
        let valueValidate = {

        };
        if(isTour) {
            validate.required.departureDate = formatValidation(t('validation.statusCode.code.1'), t(`item.tour.departureDate`))
        }
        const result = multipleValidate(tourLine, validate, valueValidate);
        const validationTourLine = this.state.validationTourLine;
        validationTourLine[index] = result;
        this.setState({ validationTourLine });
        return Object.keys(result).length < 1;
    }

}

DepartureDate.defaultProps = {
    onChange: (tourLineIndex, fieldName, value) => { },
    onChangeDateRange: (dateData = []) => { },
    onCreate: () => { },
    onBulkCreate: () => { },
    onBulkUpdate: (tourLineBulk) => { },
    onBulkDelete: (tourLines) => { },
    onChangeTourTicketFilter: (tourTicketId) => { },
    onRemove: (tourLine, index) => { },
    onSave: (tourLine, index) => { },
    tourLines: [],
    dateRanges: [],
    dateRange: [moment().startOf('month').add(1, 'days'), moment('03-2020', 'MM-YYYY').endOf('month')],
}


